export default "__VITE_ASSET__7bPDgw_d__"